module.exports = "<rt-component-demo></rt-component-demo>\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/routes/react-demo/react-demo.html
 ** module id = 497
 ** module chunks = 0
 **/